/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ author: NonNullable<unknown>, source: NonNullable<unknown> }} Recipe_Source_ByInputs */

const en_recipe_source_by = /** @type {(inputs: Recipe_Source_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.author} on ${i?.source}`)
};

const de_recipe_source_by = /** @type {(inputs: Recipe_Source_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.author} auf ${i?.source}`)
};

/**
* | output |
* | --- |
* | "From {author} on {source}" |
*
* @param {Recipe_Source_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_source_by = /** @type {((inputs: Recipe_Source_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Source_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_source_by(inputs)
	return en_recipe_source_by(inputs)
});